import {
	apiClient,
	getAuthHeaders,
	handleServiceError,
} from 'api/config/config';

// Notification Services
export const notificationService = {
	// --- CRUD --- //
	getAll: async (token) => {
		try {
			return await apiClient.post(
				'client/api/v1/notification/list',
				{
					options: {
						paginate: 100,
						sort: { id: -1 },
						where: { recipient: 'client' },
					},
					isCountOnly: false,
				},
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
	countPending: async (token) => {
		try {
			return await apiClient.post(
				'client/api/v1/notification/count',
				{ where: { recipient: 'client', viewed: false } },
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
	setAsViewed: async (token, id) => {
		try {
			return await apiClient.put(
				'client/api/v1/notification/partial-update/' + id,
				{ viewed: true },
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
	setAllAsViewed: async (token) => {
		try {
			return await apiClient.put(
				'client/api/v1/notification/updateBulk',
				{
					filter: { recipient: 'client', viewed: false },
					data: { viewed: true },
				},
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
};
